"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initI18n = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var Common_i18n_en_1 = require("./modules/Common/Common.i18n.en");
var Assessment_i18n_en_1 = require("./modules/Assessment/Assessment.i18n.en");
var Learnosity_i18n_en_1 = require("./modules/Learnosity/Learnosity.i18n.en");
var initI18n = function () {
    var resources = {
        en: __assign(__assign(__assign({}, Common_i18n_en_1.CommonI18nEn), Assessment_i18n_en_1.AssessmentI18nEn), Learnosity_i18n_en_1.LearnosityI18nEn),
    };
    i18next_1.default.use(react_i18next_1.initReactI18next).init({
        ns: ['common'],
        defaultNS: '',
        debug: false,
        resources: resources,
        fallbackLng: 'en',
        lng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });
};
exports.initI18n = initI18n;
